import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_OTHER_ARTICLES_SUCCESS = 'GET_OTHER_ARTICLES_SUCCESS';
export const GET_OTHER_ARTICLES_CLEAR = 'GET_OTHER_ARTICLES_CLEAR';

function receive(otherArticles) {
  return {
    type: GET_OTHER_ARTICLES_SUCCESS,
    otherArticles
  };
}

function clear() {
  return {
    type: GET_OTHER_ARTICLES_CLEAR
  };
}

export function getOtherArticles(treatyCountry) {
  return (dispatch) => {
    const promise = () => ApiService
      .getOtherArticles(treatyCountry)
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, clear, false));
        }
      });
    return promise();
  };
}

export function clearOtherArticles() {
  return dispatch => dispatch(clear());
}
